<template>
  <ODialog
    ref="dialog"
    :title="$t('components.courseRun.actions.delete.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $notification, $i18n } = useNuxtApp()

const dialog = ref()
const course = ref<any>(null)

const runLabel = computed(() => course.value?.course?.name ?? course.value?.information)

const info = computed(() => {
  return $i18n.t('components.courseRun.actions.delete.info', {
    name: runLabel.value,
    id: course.value?.idCourseRun,
  })
})

const open = (courseItem: any) => {
  course.value = courseItem
  dialog.value.open()
}

const confirm = async () => {
  if (!course.value) return

  emit('update:loading', true)

  try {
    const success = await $api.course.deleteRunById(course.value.idCourseRun)
    emit('update:loading', false)

    if (success) {
      $notification.toast({
        title: $i18n.t('components.courseRun.actions.delete.deletedTitle'),
        text: $i18n.t('components.courseRun.actions.delete.deletedText', { name: runLabel.value }),
      })

      emit('success')

      return true
    }
  } catch (e) {
    $notification.toast({
      title: $i18n.t('components.courseRun.actions.delete.errorDeletingTitle'),
      text: $i18n.t('components.courseRun.actions.delete.errorDeletingText', { name: runLabel.value }),
    })

    emit('error')
  }
}

defineExpose({
  open,
})
</script>
